import { SoapUtils } from "../../../utils/SoapUtils";

export interface Item {
    aclh?:                    string;
    amount?:                  string;
    parentAmount?:            string;
    amountWithVat?:           string;
    billingDate?:             string;
    componentCategory?:       string;
    componentCategoryName?:   string;
    created?:                 string;
    createdBy?:               string;
    createdByName?:           string;
    creditAccount?:           string;
    creditAccountName?:       string;
    currency?:                string;
    currencyName?:            string;
    debitAccount?:            string;
    debitAccountName?:        string;
    field0?:                  string;
    field0_id?:               string;
    field1?:                  string;
    field1_id?:               string;
    field2?:                  string;
    field2_id?:               string;
    field3?:                  string;
    field3_id?:               string;
    field4?:                  string;
    field4_id?:               string;
    field5?:                  string;
    field5_id?:               string;
    field6?:                  string;
    field6_id?:               string;
    field7?:                  string;
    field7_id?:               string;
    field8?:                  string;
    field8_id?:               string;
    field9?:                  string;
    field9_id?:               string;
    folderId?:                string;
    formId?:                  string;
    formName?:                string;
    formValue?:               string;
    id?:                      string;
    manufacturer?:            string;
    manufacturerAclh?:        string;
    manufacturerName?:        string;
    manufacturerStatus?:      string;
    manufacturerStatusColor?: string;
    manufacturerStatusName?:  string;
    modified?:                string;
    modifiedBy?:              string;
    modifiedByName?:          string;
    name?:                    string;
    note?:                    string;
    priceType?:               string;
    priceTypeName?:           string;
    purchasePrice?:           string;
    quantity?:                string;
    refId?:                   string;
    status?:                  string;
    statusShow?:              string;
    statusName?:              string;
    templateAclh?:            string;
    treeHandle?:              string;
    type?:                    string;
    typeName?:                string;
    units?:                   string;
    unitsName?:               string;
    vat?:                     string;
    vatName?:                 string;
    vatValue?:                string;
    ratio?:                   string;
    dimension1name?:          string;
    dimension1?:              string;
    dimension2name?:          string;
    dimension2?:              string;
    dimension3name?:          string;
    dimension3?:              string;
    costSplitSwitch?:         string;
    revenueSplitSwitch?:      string;
    measureStock?:            string;
    openingBalanceQty?:       string;
    openingBalanceDate?:      string;
    closingBalanceQty?:       string;
    availableBalanceQty?:     string;
    COSTSHARES?:              Shares;
    REVENUESHARES?:           Shares;
    CATEGORY?:                Category[];
    ROLE?:                    Role[];
    PRICE_GROUP?:             PriceGroup[];
    SUBJECT_PRICE_GROUP?:     PriceGroup[];
    COMPONENT?:               Component[];
    EXTERNAL_IDS?:            ExternalIDS;
}

export function toItemXml(item: Item): string {
    var xml = '<ITEM>';
    xml += SoapUtils.makeNode(item.aclh, 'aclh');
    xml += SoapUtils.makeNode(item.amount, 'amount');
    xml += SoapUtils.makeNode(item.parentAmount, 'parentAmount');
    xml += SoapUtils.makeNode(item.amountWithVat, 'amountWithVat');
    xml += SoapUtils.makeNode(item.billingDate, 'billingDate');
    xml += SoapUtils.makeNode(item.componentCategory, 'componentCategory');
    xml += SoapUtils.makeNode(item.componentCategoryName, 'componentCategoryName');
    xml += SoapUtils.makeNode(item.created, 'created');
    xml += SoapUtils.makeNode(item.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(item.createdByName, 'createdByName');
    xml += SoapUtils.makeNode(item.creditAccount, 'creditAccount');
    xml += SoapUtils.makeNode(item.creditAccountName, 'creditAccountName');
    xml += SoapUtils.makeNode(item.currency, 'currency');
    xml += SoapUtils.makeNode(item.currencyName, 'currencyName');
    xml += SoapUtils.makeNode(item.debitAccount, 'debitAccount');
    xml += SoapUtils.makeNode(item.debitAccountName, 'debitAccountName');
    xml += SoapUtils.makeNode(item.field0, 'field0');
    xml += SoapUtils.makeNode(item.field0_id, 'field0_id');
    xml += SoapUtils.makeNode(item.field1, 'field1');
    xml += SoapUtils.makeNode(item.field1_id, 'field1_id');
    xml += SoapUtils.makeNode(item.field2, 'field2');
    xml += SoapUtils.makeNode(item.field2_id, 'field2_id');
    xml += SoapUtils.makeNode(item.field3, 'field3');
    xml += SoapUtils.makeNode(item.field3_id, 'field3_id');
    xml += SoapUtils.makeNode(item.field4, 'field4');
    xml += SoapUtils.makeNode(item.field4_id, 'field4_id');
    xml += SoapUtils.makeNode(item.field5, 'field5');
    xml += SoapUtils.makeNode(item.field5_id, 'field5_id');
    xml += SoapUtils.makeNode(item.field6, 'field6');
    xml += SoapUtils.makeNode(item.field6_id, 'field6_id');
    xml += SoapUtils.makeNode(item.field7, 'field7');
    xml += SoapUtils.makeNode(item.field7_id, 'field7_id');
    xml += SoapUtils.makeNode(item.field8, 'field8');
    xml += SoapUtils.makeNode(item.field8_id, 'field8_id');
    xml += SoapUtils.makeNode(item.field9, 'field9');
    xml += SoapUtils.makeNode(item.field9_id, 'field9_id');
    xml += SoapUtils.makeNode(item.folderId, 'folderId');
    xml += SoapUtils.makeNode(item.formId, 'formId');
    xml += SoapUtils.makeNode(item.formName, 'formName');
    xml += SoapUtils.makeNode(item.formValue, 'formValue');
    xml += SoapUtils.makeNode(item.id, 'id');
    xml += SoapUtils.makeNode(item.manufacturer, 'manufacturer');
    xml += SoapUtils.makeNode(item.manufacturerAclh, 'manufacturerAclh');
    xml += SoapUtils.makeNode(item.manufacturerName, 'manufacturerName');
    xml += SoapUtils.makeNode(item.manufacturerStatus, 'manufacturerStatus');
    xml += SoapUtils.makeNode(item.manufacturerStatusColor, 'manufacturerStatusColor');
    xml += SoapUtils.makeNode(item.manufacturerStatusName, 'manufacturerStatusName');
    xml += SoapUtils.makeNode(item.modified, 'modified');
    xml += SoapUtils.makeNode(item.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(item.modifiedByName, 'modifiedByName');
    xml += SoapUtils.makeNode(item.name, 'name');
    xml += SoapUtils.makeNode(item.note, 'note');
    xml += SoapUtils.makeNode(item.priceType, 'priceType');
    xml += SoapUtils.makeNode(item.priceTypeName, 'priceTypeName');
    xml += SoapUtils.makeNode(item.purchasePrice, 'purchasePrice');
    xml += SoapUtils.makeNode(item.quantity, 'quantity');
    xml += SoapUtils.makeNode(item.refId, 'refId');
    xml += SoapUtils.makeNode(item.status, 'status');
    xml += SoapUtils.makeNode(item.statusShow, 'statusShow');
    xml += SoapUtils.makeNode(item.statusName, 'statusName');
    xml += SoapUtils.makeNode(item.templateAclh, 'templateAclh');
    xml += SoapUtils.makeNode(item.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(item.type, 'type');
    xml += SoapUtils.makeNode(item.typeName, 'typeName');
    xml += SoapUtils.makeNode(item.units, 'units');
    xml += SoapUtils.makeNode(item.unitsName, 'unitsName');
    xml += SoapUtils.makeNode(item.vat, 'vat');
    xml += SoapUtils.makeNode(item.vatName, 'vatName');
    xml += SoapUtils.makeNode(item.vatValue, 'vatValue');
    xml += SoapUtils.makeNode(item.ratio, 'ratio');
    xml += SoapUtils.makeNode(item.dimension1name, 'dimension1name');
    xml += SoapUtils.makeNode(item.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(item.dimension2name, 'dimension2name');
    xml += SoapUtils.makeNode(item.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(item.dimension3name, 'dimension3name');
    xml += SoapUtils.makeNode(item.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(item.costSplitSwitch, 'costSplitSwitch');
    xml += SoapUtils.makeNode(item.revenueSplitSwitch, 'revenueSplitSwitch');
    xml += SoapUtils.makeNode(item.measureStock, 'measureStock');
    xml += SoapUtils.makeNode(item.openingBalanceQty, 'openingBalanceQty');
    xml += SoapUtils.makeNode(item.openingBalanceDate, 'openingBalanceDate');
    xml += SoapUtils.makeNode(item.closingBalanceQty, 'closingBalanceQty');
    xml += SoapUtils.makeNode(item.availableBalanceQty, 'availableBalanceQty');
    if (item.COSTSHARES) xml += toSharesXml(item.COSTSHARES, 'COSTSHARES');
    if (item.REVENUESHARES) xml += toSharesXml(item.REVENUESHARES, 'REVENUESHARES');
    if (item.CATEGORY) xml += item.CATEGORY.map(toCategoryXml).join('');
    if (item.ROLE) xml += item.ROLE.map(toRoleXml).join('');
    if (item.PRICE_GROUP) xml += item.PRICE_GROUP.map(toPriceGroupXml).join('');
    if (item.SUBJECT_PRICE_GROUP) xml += item.SUBJECT_PRICE_GROUP.map(toPriceGroupXml).join('');
    if (item.COMPONENT) xml += item.COMPONENT.map(toComponentXml).join('');
    if (item.EXTERNAL_IDS) xml += toExternalIdsXml(item.EXTERNAL_IDS);
    xml += '</ITEM>';
    return xml;
}

export interface Category {
    category?:   string;
    id?:         string;
    name?:       string;
    remove?:     string;
    treeHandle?: string;
}

export function toCategoryXml(category: Category): string {
    var xml = '<CATEGORY>';
    xml += SoapUtils.makeNode(category.category, 'category');
    xml += SoapUtils.makeNode(category.id, 'id');
    xml += SoapUtils.makeNode(category.name, 'name');
    xml += SoapUtils.makeNode(category.remove, 'remove');
    xml += SoapUtils.makeNode(category.treeHandle, 'treeHandle');
    xml += '</CATEGORY>';
    return xml;
}

export interface Component {
    component?:     string;
    countMin?:      string;
    countMax?:      string;
    priceInclude?:  string;
    note?:          string;
    ratio?:         string;
    componentType?: string;
    componentName?: string;
    amount?:        string;
    amountWithVat?: string;
    purchasePrice?: string;
    vatName?:       string;
    vatValue?:      string;
    currency?:      string;
    currencyName?:  string;
    isParent?:      string;
    remove?:        string;
}

export function toComponentXml(component: Component): string {
    var xml = '<COMPONENT>';
    xml += SoapUtils.makeNode(component.component, 'component');
    xml += SoapUtils.makeNode(component.countMin, 'countMin');
    xml += SoapUtils.makeNode(component.countMax, 'countMax');
    xml += SoapUtils.makeNode(component.priceInclude, 'priceInclude');
    xml += SoapUtils.makeNode(component.note, 'note');
    xml += SoapUtils.makeNode(component.ratio, 'ratio');
    xml += SoapUtils.makeNode(component.componentType, 'componentType');
    xml += SoapUtils.makeNode(component.componentName, 'componentName');
    xml += SoapUtils.makeNode(component.amount, 'amount');
    xml += SoapUtils.makeNode(component.amountWithVat, 'amountWithVat');
    xml += SoapUtils.makeNode(component.purchasePrice, 'purchasePrice');
    xml += SoapUtils.makeNode(component.vatName, 'vatName');
    xml += SoapUtils.makeNode(component.vatValue, 'vatValue');
    xml += SoapUtils.makeNode(component.currency, 'currency');
    xml += SoapUtils.makeNode(component.currencyName, 'currencyName');
    xml += SoapUtils.makeNode(component.isParent, 'isParent');
    xml += SoapUtils.makeNode(component.remove, 'remove');
    xml += '</COMPONENT>';
    return xml;
}

export interface Shares {
    SHARE?: Share[];
}

export function toSharesXml(shares: Shares, nodeName: string = 'SHARES'): string {
    var xml = `<${nodeName}>`;
    if (shares.SHARE) xml += shares.SHARE.map(toShareXml).join('');
    xml += `</${nodeName}>`;
    return xml;
}

export interface Share {
    acl?:            string;
    GLItem?:         string;
    GLItemName?:     string;
    id?:             string;
    max_len?:        string;
    name?:           string;
    priority?:       string;
    recordId?:       string;
    remove?:         string;
    share?:          string;
    templateAcc?:    string;
    treeHandle?:     string;
    userId?:         string;
    userName?:       string;
    folder?:         string;
    project?:        string;
    activity?:       string;
    isRemaining?:    string;
    units?:          string;
    shareUnits?:     string;
    percentage?:     string;
    total?:          string;
    dimension1?:     string;
    dimension2?:     string;
    dimension3?:     string;
    dimension1Name?: string;
    dimension2Name?: string;
    dimension3Name?: string;
}

export function toShareXml(share: Share): string {
    var xml = '<SHARE>';
    xml += SoapUtils.makeNode(share.acl, 'acl');
    xml += SoapUtils.makeNode(share.GLItem, 'GLItem');
    xml += SoapUtils.makeNode(share.GLItemName, 'GLItemName');
    xml += SoapUtils.makeNode(share.id, 'id');
    xml += SoapUtils.makeNode(share.max_len, 'max_len');
    xml += SoapUtils.makeNode(share.name, 'name');
    xml += SoapUtils.makeNode(share.priority, 'priority');
    xml += SoapUtils.makeNode(share.recordId, 'recordId');
    xml += SoapUtils.makeNode(share.remove, 'remove');
    xml += SoapUtils.makeNode(share.share, 'share');
    xml += SoapUtils.makeNode(share.templateAcc, 'templateAcc');
    xml += SoapUtils.makeNode(share.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(share.userId, 'userId');
    xml += SoapUtils.makeNode(share.userName, 'userName');
    xml += SoapUtils.makeNode(share.folder, 'folder');
    xml += SoapUtils.makeNode(share.project, 'project');
    xml += SoapUtils.makeNode(share.activity, 'activity');
    xml += SoapUtils.makeNode(share.isRemaining, 'isRemaining');
    xml += SoapUtils.makeNode(share.units, 'units');
    xml += SoapUtils.makeNode(share.shareUnits, 'shareUnits');
    xml += SoapUtils.makeNode(share.percentage, 'percentage');
    xml += SoapUtils.makeNode(share.total, 'total');
    xml += SoapUtils.makeNode(share.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(share.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(share.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(share.dimension1Name, 'dimension1Name');
    xml += SoapUtils.makeNode(share.dimension2Name, 'dimension2Name');
    xml += SoapUtils.makeNode(share.dimension3Name, 'dimension3Name');
    xml += '</SHARE>';
    return xml;
}
export interface ExternalIDS {
    EXTERNAL_ID?: ExternalID[];
}

export function toExternalIdsXml(externalIds: ExternalIDS): string {
    var xml = '<EXTERNAL_IDS>';
    if (externalIds.EXTERNAL_ID) xml += externalIds.EXTERNAL_ID.map(toExternalIdXml).join('');
    xml += '</EXTERNAL_IDS>';
    return xml;
}

export interface ExternalID {
    externalSystem?: string;
    externalId?:     string;
}

export function toExternalIdXml(externalId: ExternalID): string {
    var xml = '<EXTERNAL_ID>';
    xml += SoapUtils.makeNode(externalId.externalSystem, 'externalSystem');
    xml += SoapUtils.makeNode(externalId.externalId, 'externalId');
    xml += '</EXTERNAL_ID>';
    return xml;
}

export interface PriceGroup {
    active?:         string;
    folder?:         string;
    folderName?:     string;
    id?:             string;
    item?:           string;
    itemName?:       string;
    priceGroup?:     string;
    priceGroupName?: string;
    sale?:           string;
    validFrom?:      string;
    validTo?:        string;
}

export function toPriceGroupXml(priceGroup: PriceGroup): string {
    var xml = '<PRICE_GROUP>';
    xml += SoapUtils.makeNode(priceGroup.active, 'active');
    xml += SoapUtils.makeNode(priceGroup.folder, 'folder');
    xml += SoapUtils.makeNode(priceGroup.folderName, 'folderName');
    xml += SoapUtils.makeNode(priceGroup.id, 'id');
    xml += SoapUtils.makeNode(priceGroup.item, 'item');
    xml += SoapUtils.makeNode(priceGroup.itemName, 'itemName');
    xml += SoapUtils.makeNode(priceGroup.priceGroup, 'priceGroup');
    xml += SoapUtils.makeNode(priceGroup.priceGroupName, 'priceGroupName');
    xml += SoapUtils.makeNode(priceGroup.sale, 'sale');
    xml += SoapUtils.makeNode(priceGroup.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(priceGroup.validTo, 'validTo');
    xml += '</PRICE_GROUP>';
    return xml;
}

export interface Role {
    folder?:     string;
    folderName?: string;
    id?:         string;
    item?:       string;
    name?:       string;
    remove?:     string;
    role?:       string;
    treeHandle?: string;
}

export function toRoleXml(role: Role): string {
    var xml = '<ROLE>';
    xml += SoapUtils.makeNode(role.folder, 'folder');
    xml += SoapUtils.makeNode(role.folderName, 'folderName');
    xml += SoapUtils.makeNode(role.id, 'id');
    xml += SoapUtils.makeNode(role.item, 'item');
    xml += SoapUtils.makeNode(role.name, 'name');
    xml += SoapUtils.makeNode(role.remove, 'remove');
    xml += SoapUtils.makeNode(role.role, 'role');
    xml += SoapUtils.makeNode(role.treeHandle, 'treeHandle');
    xml += '</ROLE>';
    return xml;
}